import React, { Component } from "react";
import { fire, auth } from "../../../firebase/index";
//? English Version
import addLockInstruction1 from "../../../assets/img/tutorialimages/registerLockGuide1.png";
import addLockInstruction2 from "../../../assets/img/tutorialimages/registerLockGuide2.png";
import addLockInstruction3 from "../../../assets/img/tutorialimages/registerLockGuide3.png";
//? Japanese Version
import addLockInstruction1Jap from "../../../assets/img/tutorialimages/registerLockGuide1_Jap.png";
import addLockInstruction2Jap from "../../../assets/img/tutorialimages/registerLockGuide2_Jap.png";
import addLockInstruction3Jap from "../../../assets/img/tutorialimages/registerLockGuide3_Jap.png";

class RegisterLockGuide extends Component {
  state = {
    language: "en",
  };

  componentDidMount() {
    if (auth.currentUser !== null) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .on("value", this._langCb = (snapshot) => {
          this.setState({
            language: snapshot.val(),
          });
        });
    }
  }

  componentWillUnmount() {
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    const { language } = this.state;
    return (
      <div
        style={{
          width: "90%",
          marginLeft: "auto",
          marginRight: "auto",
        }}
      >
        <img
          className="imgStyle"
          src={
            language === "en"
              ? addLockInstruction1
              : language === "ja"
              ? addLockInstruction1Jap
              : language === "es"
              ? addLockInstruction1
              : addLockInstruction1
          }
          alt="addLockInstruction1"
          style={{
            width: "100%",
            marginLeft: "auto",
            marginRight: "auto",
            height: "100%",
          }}
        />
        <img
          className="imgStyle"
          src={
            language === "en"
              ? addLockInstruction2
              : language === "ja"
              ? addLockInstruction2Jap
              : language === "es"
              ? addLockInstruction2
              : addLockInstruction2
          }
          alt="addLockInstruction2"
          style={{
            width: "100%",
            marginLeft: "auto",
            marginRight: "auto",
            height: "100%",
          }}
        />
        <img
          className="imgStyle"
          src={
            language === "en"
              ? addLockInstruction3
              : language === "ja"
              ? addLockInstruction3Jap
              : language === "es"
              ? addLockInstruction3
              : addLockInstruction3
          }
          alt="addLockInstruction3"
          style={{
            width: "100%",
            marginLeft: "auto",
            marginRight: "auto",
            height: "100%",
          }}
        />
      </div>
    );
  }
}

export default RegisterLockGuide;
